// extracted by mini-css-extract-plugin
export default {"reads":"Reads_reads__R25XP","container":"Reads_container__nS3aM"};